module.exports = __webpack_public_path__ + "static/media/tourism-boards-6.67ed2a90.jpg";